import React, { useContext, useEffect } from 'react'
import styles from '../styles.module.css'
import Table from '../../../components/Table'
import { useDispatch, useSelector } from 'react-redux'
import { getAttendances } from '../../../actions/classbook'
import { ClassbookContext } from '../../../utils/context'

export default function Attendance() {
  const dispatch = useDispatch()

  const { formData } = useContext(ClassbookContext)

  const { attendance } = useSelector(state => state.classbook)

  useEffect(() => {
    const { studyPeriod: trmid, class: gid } = formData
    trmid && gid && dispatch(getAttendances(trmid, gid))
  }, [formData])
  // ПУСТОЙ ПРИХОДИТ
  const renderLi = (data) => {
    const { fio, gr, kolvo_days } = data
    return (
      <tr >
        <td>{fio}</td>
        <td>{fio}</td>
      </tr>
    )
  }

  return (
    <div >

      <Table className={styles.tables}>
        <thead>
          <tr>
            <th>№ п/п</th>
            <th>Фамилия И.О.</th>
          </tr>
        </thead>
        <tbody>
          {attendance?.length ?
            attendance?.map(renderLi) :
            <tr>
              <td colSpan={4}>Нет данных</td>
            </tr>
          }
        </tbody>
      </Table>
    </div>
  )
}
